module.exports = __webpack_public_path__ + "static/media/banner.6b134c60.png";